import { Link } from "react-router";
import { useTranslation } from "react-i18next";

// Catch-all 404. Rendered inside AppLayout (see routes.tsx) so the sidebar,
// header and footer stay in place and the user always has a way back.
export function NotFound() {
  const { t } = useTranslation("common");

  return (
    <div className="text-center py-5">
      <div
        className="text-body-secondary text-uppercase fw-semibold mb-2"
        style={{ letterSpacing: "0.1em" }}
      >
        {t("notFound.eyebrow")}
      </div>
      <h1 className="display-5 fw-semibold mb-3">{t("notFound.title")}</h1>
      <p className="text-body-secondary mb-4 mx-auto" style={{ maxWidth: 520 }}>
        {t("notFound.message")}
      </p>
      <div className="d-flex gap-2 justify-content-center flex-wrap">
        <Link to="/" className="btn btn-primary">
          {t("notFound.backToDashboard")}
        </Link>
        <Link to="/strategies" className="btn btn-outline-secondary">
          {t("notFound.browseStrategies")}
        </Link>
      </div>
    </div>
  );
}
